'use strict';
checkList.classy.controller({
    name: 'HomemakerDetectedController',
    inject: ['$scope', 'RestService', 'ApplicationService', 'PutService', 'AlertService', 'ResetService'],
    init: function () {
        this.$.AlertService = this.AlertService;

        this.$.setAnswer(67);
        this.$.answer.amount = this.ApplicationService.getAwardData().policy[0]['Pref_1_default'];
        if (this.ApplicationService.getFamilyData().apWizard.case67ans!=='') {
            let str = JSON.parse(this.ApplicationService.getFamilyData().apWizard.case67ans);
            this.$.answer.amount = str.amount; 
        }

    },
    homemakerDetectedCompleted: function ()
    {
        var caseNo = 'case67';
        var queue = [];
        var hmfield = this.AlertService.getHomemakerAnnualField(); //homemaker's income field from edit sums

        if (this.$.answer.choice == 0) //don't impute
        {
            this.ResetService.resetNoPrompt('Homemaker_Alert'); 
            delete this.$.answer.amount;
        }
        else if (this.$.answer.choice == 1) //impute custom amount
        {
            this.ApplicationService.getFamilyData().edit_sums[hmfield] = parseInt(this.$.answer.amount);
            queue.push(this.PutService.putEditSums());
        }
        this.$.alertPut(queue, caseNo, 0, this.$.answer);
    }
});
